import React from 'react';
import type { FlightsInfoBanners } from '@lt/api/dist/methods/packages/types';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import CheckoutFlightsBanner from '../CheckoutFlightsBanner/CheckoutFlightsBanner';
import styles from './CheckoutBannersList.module.css';

type Props = {
  items: FlightsInfoBanners[];
  isMobile: boolean;
};

// делаю два return со свайпером для мобилки и без свайпера для десктопа

const CheckoutBannersList = ({ items, isMobile }: Props): JSX.Element => {
  if (isMobile)
    return (
      <Swiper
        slidesPerView="auto"
        height={72}
        spaceBetween={items.length > 1 ? '8px' : '0px'}
        parallax
      >
        <div
          className={styles.checkoutBannersContainer}
          data-testid="banners-test-id"
        >
          {/** поставила стиль не вунтри класса, так как на классовый flex он не реагирует */}
          {items.map((data) => (
            <SwiperSlide
              key={data.title}
              className={classNames({ [styles.fullBannerContainer]: isMobile })}
              style={{ flex: 'auto' }}
            >
              <CheckoutFlightsBanner
                title={data.title}
                fullText={data.description}
                imageSrc={data.icon.webp}
                imageFallback={data.icon.png}
                isMobile={isMobile}
                key={data.title}
              />
            </SwiperSlide>
          ))}
        </div>
      </Swiper>
    );

  return (
    <div
      className={styles.checkoutBannersContainer}
      data-testid="banners-test-id"
    >
      {items.map((data) => (
        <CheckoutFlightsBanner
          title={data.title}
          fullText={data.description}
          imageSrc={data.icon.webp}
          imageFallback={data.icon.png}
          isMobile={isMobile}
          key={data.title}
        />
      ))}
    </div>
  );
};

export default CheckoutBannersList;
